import React from 'react';
import './PageNotFound.styles.css';
import { useNavigate } from 'react-router-dom';

export const PageNotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="notfound-container">
            <h1 className="notfound-title">404</h1>
            <p className="notfound-subtitle">Trang không tồn tại</p>
            <p className="notfound-message">
                Trang bạn đang tìm kiếm không tồn tại hoặc đã bị xóa.
            </p>
            <button className="notfound-button" onClick={() => navigate("/")}>
                Quay lại trang chủ
            </button>
        </div>
    )
}